module.exports = __webpack_public_path__ + "static/media/multilisting.4267e606.png";